import './style.scss';
import { Timer } from '../../../js/components/Timer/Timer';
import { saleEndDate } from '../../../js/components/SaleEndDate/SaleEndDate';
import { ClassName } from '../../../js/Form/const';

export default !function () {
  const block = document.querySelector('.price-v11');

  if (!block) {
    return;
  }

  const blockName = block.dataset.blockName || 'Блок без названия';
  const form = block.querySelector('.form');
  const buttonsWrapper = block.querySelector('.price-v11__buttons');
  const visibleButtons = buttonsWrapper ? [...buttonsWrapper.querySelectorAll('[data-submit-type]')] : [];
  const hiddenSubmitButton = buttonsWrapper?.querySelector('button[type="submit"]');
  const submitTypeInput = form?.querySelector('input[name="submit_type"]');
  const b2b = block.querySelector('.ui-checkbox-field__input[name="is_jur_person"]');
  const promoAccepted = block.querySelector('.ui-checkbox-field__input[name="promo_accepted"]');

  const syncButtonsState = (isDisabled) => {
    visibleButtons.forEach((button) => {
      button.disabled = isDisabled;
      isDisabled
        ? button.classList.add(ClassName.LOADING)
        : button.classList.remove(ClassName.LOADING);
    });
  };

  if (buttonsWrapper && hiddenSubmitButton && submitTypeInput && visibleButtons.length) {
    syncButtonsState(hiddenSubmitButton.disabled);

    buttonsWrapper.addEventListener('click', (evt) => {
      const button = evt.target.closest('[data-submit-type]');

      if (!button || button.disabled) {
        return;
      }

      submitTypeInput.value = button.dataset.submitType;
      hiddenSubmitButton.click();
    });

    new MutationObserver(() => {
      syncButtonsState(hiddenSubmitButton.disabled);
    }).observe(hiddenSubmitButton, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  }

  form?.addEventListener('form-sended', (evt) => {
    window.$analytics?.push('price-form-send', {
      requestId: evt.sendingResult?.formData.get('request_id'),
      label: evt.sendingResult?.formData.get('submit_type') || evt.sendingResult?.formData.get('payment_type'),
      blockName,
      legalEntity: Number(b2b?.checked),
      promoAccepted: Number(promoAccepted?.checked),
    });
  });

  const timerWrapper = block.querySelector('.price-v11__timer-block');

  if (timerWrapper) {
    saleEndDate.addObserver(time => new Timer({ time, timerWrapper }));
  }

  if (b2b) {
    const companyInput = block.querySelector('[data-field="b2b"]');
    const companyField = companyInput.closest('.form__input--hidden');

    setTimeout(() => {
      if (b2b.checked) {
        companyField.classList.add('form__input--show');
      }
    }, 100);

    b2b.addEventListener('change', () => {
      companyField.classList.toggle('form__input--show');
      companyInput.disabled = !b2b.checked;
    });
  }
}();
